import { Client, Hub, Severity } from '@sentry/types';
import { LogAppender } from '../logger';
import { stringify } from '../util';

/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */

// use the global Sentry namespace if available (we don't want to bundle Sentry with this library)
function getGlobalSentry() {
  return {
    captureMessage: (window as any).Sentry?.captureMessage as Client['captureMessage'] || function() {},
    withScope: (window as any).Sentry?.withScope as Hub['withScope'] || function() {},
    setContext: (window as any).Sentry?.setContext as Hub['setContext'] || function() {}
  }
}

/**
 * Log appender that writes to Sentry
 */
export const sentryAppender: LogAppender = {
  warn: (...args) => {
    getGlobalSentry().captureMessage(stringify(args), Severity.Warning);
  },
  error: (...args) => {
    getGlobalSentry().captureMessage(stringify(args), Severity.Error);
  },
  errorWithScope: (contextName: string, contextValue: {[index: string]: any}, ...args: any[]) => {
    const Sentry = getGlobalSentry()
    /* istanbul ignore else */
    Sentry.withScope(() => {
      Sentry.setContext(contextName, contextValue);
      Sentry.captureMessage(stringify(args), Severity.Error);
    });
  }
};
